import LanguagesApi from '../../../Api/CRM/Modules/LanguagesApi';
import AbstractCasinoCRMApi from '../AbstractCasinoCRMApi';

import CasinoAffiliatesApi from './Modules/CasinoAffiliatesApi';
import CasinoBonusesApi from './Modules/CasinoBonusesApi';
import CasinoGameApi from './Modules/CasinoGameApi';
import CasinoGameCategoriesApi from './Modules/CasinoGameCategoriesApi';
import CasinoGameCategoryGameOrderApi from './Modules/CasinoGameCategoryGameOrderApi';
import CasinoTransactionsApi from './Modules/CasinoTransactionsApi';
import CasinoUserBonusesApi from './Modules/CasinoUserBonusesApi';
import DetailedBreakdownApi from './Modules/DetailedBreakdownApi';
import NewsGamesWidgetApi from './Modules/NewsGamesWidget';
import SeoSettingsApi from './Modules/SeoSettingsApi';

class CasinoCRMApi extends AbstractCasinoCRMApi {
    public transactions = CasinoTransactionsApi;
    public seoSettingsApi = SeoSettingsApi;
    public detailedBreakdown = DetailedBreakdownApi;
    public userBonuses = CasinoUserBonusesApi;
    public bonuses = CasinoBonusesApi;
    public affiliates = CasinoAffiliatesApi;
    public gameCategories = CasinoGameCategoriesApi;
    public languages = LanguagesApi;
    public games = CasinoGameApi;
    public gameCategoryGameOrder = CasinoGameCategoryGameOrderApi;
    public newsGamesWidget = NewsGamesWidgetApi;
}

export default new CasinoCRMApi();
